'use client';

import { hofPhosphorAdapter } from "./src/assets/icons/hofPhosphorAdapter.js";
import { AndroidLogo as A } from "./external/@phosphor-icons/react/dist/csr/AndroidLogo.js";
import { AppleLogo as A$1 } from "./external/@phosphor-icons/react/dist/csr/AppleLogo.js";
import { AppStoreLogo as A$2 } from "./external/@phosphor-icons/react/dist/csr/AppStoreLogo.js";
import { ArrowArcLeft as I } from "./external/@phosphor-icons/react/dist/csr/ArrowArcLeft.js";
import { ArrowCircleUp as C } from "./external/@phosphor-icons/react/dist/csr/ArrowCircleUp.js";
import { ArrowDown as D } from "./external/@phosphor-icons/react/dist/csr/ArrowDown.js";
import { ArrowDownLeft as D$1 } from "./external/@phosphor-icons/react/dist/csr/ArrowDownLeft.js";
import { ArrowDownRight as d } from "./external/@phosphor-icons/react/dist/csr/ArrowDownRight.js";
import { ArrowLeft as I$1 } from "./external/@phosphor-icons/react/dist/csr/ArrowLeft.js";
import { ArrowRight as d$1 } from "./external/@phosphor-icons/react/dist/csr/ArrowRight.js";
import { ArrowsLeftRight as d$2 } from "./external/@phosphor-icons/react/dist/csr/ArrowsLeftRight.js";
import { ArrowsInSimple as A$3 } from "./external/@phosphor-icons/react/dist/csr/ArrowsInSimple.js";
import { ArrowsOutSimple as A$4 } from "./external/@phosphor-icons/react/dist/csr/ArrowsOutSimple.js";
import { ArrowSquareIn as q } from "./external/@phosphor-icons/react/dist/csr/ArrowSquareIn.js";
import { ArrowSquareOut as q$1 } from "./external/@phosphor-icons/react/dist/csr/ArrowSquareOut.js";
import { ArrowUp as I$2 } from "./external/@phosphor-icons/react/dist/csr/ArrowUp.js";
import { ArrowUpLeft as I$3 } from "./external/@phosphor-icons/react/dist/csr/ArrowUpLeft.js";
import { ArrowUpRight as d$3 } from "./external/@phosphor-icons/react/dist/csr/ArrowUpRight.js";
import { ArrowUUpLeft as A$5 } from "./external/@phosphor-icons/react/dist/csr/ArrowUUpLeft.js";
import { ArrowUUpRight as n } from "./external/@phosphor-icons/react/dist/csr/ArrowUUpRight.js";
import { ArrowsClockwise as A$6 } from "./external/@phosphor-icons/react/dist/csr/ArrowsClockwise.js";
import { ArrowsDownUp as D$2 } from "./external/@phosphor-icons/react/dist/csr/ArrowsDownUp.js";
import { Article as I$4 } from "./external/@phosphor-icons/react/dist/csr/Article.js";
import { Bell as I$5 } from "./external/@phosphor-icons/react/dist/csr/Bell.js";
import { BookBookmark as w } from "./external/@phosphor-icons/react/dist/csr/BookBookmark.js";
import { BookmarkSimple as w$1 } from "./external/@phosphor-icons/react/dist/csr/BookmarkSimple.js";
import { BookOpenText as l } from "./external/@phosphor-icons/react/dist/csr/BookOpenText.js";
import { Books as w$2 } from "./external/@phosphor-icons/react/dist/csr/Books.js";
import { Broadcast as I$6 } from "./external/@phosphor-icons/react/dist/csr/Broadcast.js";
import { Browsers as I$7 } from "./external/@phosphor-icons/react/dist/csr/Browsers.js";
import { CalendarBlank as w$3 } from "./external/@phosphor-icons/react/dist/csr/CalendarBlank.js";
import { CaretDoubleDown as d$4 } from "./external/@phosphor-icons/react/dist/csr/CaretDoubleDown.js";
import { CaretDoubleUp as w$4 } from "./external/@phosphor-icons/react/dist/csr/CaretDoubleUp.js";
import { CaretDown as D$3 } from "./external/@phosphor-icons/react/dist/csr/CaretDown.js";
import { CaretLeft as I$8 } from "./external/@phosphor-icons/react/dist/csr/CaretLeft.js";
import { CaretRight as l$1 } from "./external/@phosphor-icons/react/dist/csr/CaretRight.js";
import { CaretUp as I$9 } from "./external/@phosphor-icons/react/dist/csr/CaretUp.js";
import { ChartBar as w$5 } from "./external/@phosphor-icons/react/dist/csr/ChartBar.js";
import { ChartPie as C$1 } from "./external/@phosphor-icons/react/dist/csr/ChartPie.js";
import { Chats as C$2 } from "./external/@phosphor-icons/react/dist/csr/Chats.js";
import { ChatText as w$6 } from "./external/@phosphor-icons/react/dist/csr/ChatText.js";
import { Check as w$7 } from "./external/@phosphor-icons/react/dist/csr/Check.js";
import { CheckCircle as k } from "./external/@phosphor-icons/react/dist/csr/CheckCircle.js";
import { CirclesThree as C$3 } from "./external/@phosphor-icons/react/dist/csr/CirclesThree.js";
import { ClipboardText as w$8 } from "./external/@phosphor-icons/react/dist/csr/ClipboardText.js";
import { Clock as C$4 } from "./external/@phosphor-icons/react/dist/csr/Clock.js";
import { CloudCheck as k$1 } from "./external/@phosphor-icons/react/dist/csr/CloudCheck.js";
import { CloudSlash as w$9 } from "./external/@phosphor-icons/react/dist/csr/CloudSlash.js";
import { Coffee as I$a } from "./external/@phosphor-icons/react/dist/csr/Coffee.js";
import { Columns as C$5 } from "./external/@phosphor-icons/react/dist/csr/Columns.js";
import { Confetti as I$b } from "./external/@phosphor-icons/react/dist/csr/Confetti.js";
import { Copy as C$6 } from "./external/@phosphor-icons/react/dist/csr/Copy.js";
import { CodesandboxLogo as l$2 } from "./external/@phosphor-icons/react/dist/csr/CodesandboxLogo.js";
import { CreditCard as I$c } from "./external/@phosphor-icons/react/dist/csr/CreditCard.js";
import { CrownSimple as I$d } from "./external/@phosphor-icons/react/dist/csr/CrownSimple.js";
import { CurrencyCircleDollar as u } from "./external/@phosphor-icons/react/dist/csr/CurrencyCircleDollar.js";
import { CurrencyEth as l$3 } from "./external/@phosphor-icons/react/dist/csr/CurrencyEth.js";
import { CursorClick as u$1 } from "./external/@phosphor-icons/react/dist/csr/CursorClick.js";
import { Desktop as D$4 } from "./external/@phosphor-icons/react/dist/csr/Desktop.js";
import { DeviceMobileCamera as w$a } from "./external/@phosphor-icons/react/dist/csr/DeviceMobileCamera.js";
import { DotOutline as D$5 } from "./external/@phosphor-icons/react/dist/csr/DotOutline.js";
import { DotsSixVertical as D$6 } from "./external/@phosphor-icons/react/dist/csr/DotsSixVertical.js";
import { DotsThreeVertical as D$7 } from "./external/@phosphor-icons/react/dist/csr/DotsThreeVertical.js";
import { DownloadSimple as I$e } from "./external/@phosphor-icons/react/dist/csr/DownloadSimple.js";
import { Envelope as w$b } from "./external/@phosphor-icons/react/dist/csr/Envelope.js";
import { EnvelopeOpen as w$c } from "./external/@phosphor-icons/react/dist/csr/EnvelopeOpen.js";
import { Exam as w$d } from "./external/@phosphor-icons/react/dist/csr/Exam.js";
import { Export as w$e } from "./external/@phosphor-icons/react/dist/csr/Export.js";
import { Eye as w$f } from "./external/@phosphor-icons/react/dist/csr/Eye.js";
import { EyeSlash as d$5 } from "./external/@phosphor-icons/react/dist/csr/EyeSlash.js";
import { FacebookLogo as l$4 } from "./external/@phosphor-icons/react/dist/csr/FacebookLogo.js";
import { File as I$f } from "./external/@phosphor-icons/react/dist/csr/File.js";
import { FileArrowDown as D$8 } from "./external/@phosphor-icons/react/dist/csr/FileArrowDown.js";
import { FileMinus as F } from "./external/@phosphor-icons/react/dist/csr/FileMinus.js";
import { FilePdf as I$g } from "./external/@phosphor-icons/react/dist/csr/FilePdf.js";
import { FilePlus as F$1 } from "./external/@phosphor-icons/react/dist/csr/FilePlus.js";
import { FileZip as I$h } from "./external/@phosphor-icons/react/dist/csr/FileZip.js";
import { Files as I$i } from "./external/@phosphor-icons/react/dist/csr/Files.js";
import { FileText as F$2 } from "./external/@phosphor-icons/react/dist/csr/FileText.js";
import { FilmSlate as I$j } from "./external/@phosphor-icons/react/dist/csr/FilmSlate.js";
import { Flag as F$3 } from "./external/@phosphor-icons/react/dist/csr/Flag.js";
import { Folder as w$g } from "./external/@phosphor-icons/react/dist/csr/Folder.js";
import { FunnelSimple as F$4 } from "./external/@phosphor-icons/react/dist/csr/FunnelSimple.js";
import { Gear as I$k } from "./external/@phosphor-icons/react/dist/csr/Gear.js";
import { Gift as I$l } from "./external/@phosphor-icons/react/dist/csr/Gift.js";
import { GoogleLogo as G } from "./external/@phosphor-icons/react/dist/csr/GoogleLogo.js";
import { GooglePlayLogo as w$h } from "./external/@phosphor-icons/react/dist/csr/GooglePlayLogo.js";
import { GraduationCap as C$7 } from "./external/@phosphor-icons/react/dist/csr/GraduationCap.js";
import { HandPointing as H } from "./external/@phosphor-icons/react/dist/csr/HandPointing.js";
import { Handshake as w$i } from "./external/@phosphor-icons/react/dist/csr/Handshake.js";
import { Heart as I$m } from "./external/@phosphor-icons/react/dist/csr/Heart.js";
import { House as H$1 } from "./external/@phosphor-icons/react/dist/csr/House.js";
import { IdentificationCard as C$8 } from "./external/@phosphor-icons/react/dist/csr/IdentificationCard.js";
import { Image as w$j } from "./external/@phosphor-icons/react/dist/csr/Image.js";
import { Info as R } from "./external/@phosphor-icons/react/dist/csr/Info.js";
import { IntersectThree as w$k } from "./external/@phosphor-icons/react/dist/csr/IntersectThree.js";
import { Key as I$n } from "./external/@phosphor-icons/react/dist/csr/Key.js";
import { Layout as w$l } from "./external/@phosphor-icons/react/dist/csr/Layout.js";
import { Lifebuoy as u$2 } from "./external/@phosphor-icons/react/dist/csr/Lifebuoy.js";
import { Lightbulb as d$6 } from "./external/@phosphor-icons/react/dist/csr/Lightbulb.js";
import { Lightning as w$m } from "./external/@phosphor-icons/react/dist/csr/Lightning.js";
import { Link as I$o } from "./external/@phosphor-icons/react/dist/csr/Link.js";
import { LinkedinLogo as l$5 } from "./external/@phosphor-icons/react/dist/csr/LinkedinLogo.js";
import { List as L } from "./external/@phosphor-icons/react/dist/csr/List.js";
import { ListBullets as w$n } from "./external/@phosphor-icons/react/dist/csr/ListBullets.js";
import { ListChecks as w$o } from "./external/@phosphor-icons/react/dist/csr/ListChecks.js";
import { LockSimple as I$p } from "./external/@phosphor-icons/react/dist/csr/LockSimple.js";
import { MagnifyingGlass as w$p } from "./external/@phosphor-icons/react/dist/csr/MagnifyingGlass.js";
import { MapPinLine as L$1 } from "./external/@phosphor-icons/react/dist/csr/MapPinLine.js";
import { Medal as M } from "./external/@phosphor-icons/react/dist/csr/Medal.js";
import { Megaphone as w$q } from "./external/@phosphor-icons/react/dist/csr/Megaphone.js";
import { Microphone as I$q } from "./external/@phosphor-icons/react/dist/csr/Microphone.js";
import { Minus as I$r } from "./external/@phosphor-icons/react/dist/csr/Minus.js";
import { Money as I$s } from "./external/@phosphor-icons/react/dist/csr/Money.js";
import { Notebook as l$6 } from "./external/@phosphor-icons/react/dist/csr/Notebook.js";
import { Pause as I$t } from "./external/@phosphor-icons/react/dist/csr/Pause.js";
import { PaintBrushHousehold as B } from "./external/@phosphor-icons/react/dist/csr/PaintBrushHousehold.js";
import { Paperclip as P } from "./external/@phosphor-icons/react/dist/csr/Paperclip.js";
import { PaperPlaneRight as h } from "./external/@phosphor-icons/react/dist/csr/PaperPlaneRight.js";
import { PencilSimple as P$1 } from "./external/@phosphor-icons/react/dist/csr/PencilSimple.js";
import { Play as I$u } from "./external/@phosphor-icons/react/dist/csr/Play.js";
import { PlayCircle as C$9 } from "./external/@phosphor-icons/react/dist/csr/PlayCircle.js";
import { Plugs as w$r } from "./external/@phosphor-icons/react/dist/csr/Plugs.js";
import { Plus as I$v } from "./external/@phosphor-icons/react/dist/csr/Plus.js";
import { PresentationChart as C$a } from "./external/@phosphor-icons/react/dist/csr/PresentationChart.js";
import { Prohibit as w$s } from "./external/@phosphor-icons/react/dist/csr/Prohibit.js";
import { PushPinSimple as u$3 } from "./external/@phosphor-icons/react/dist/csr/PushPinSimple.js";
import { Question as I$w } from "./external/@phosphor-icons/react/dist/csr/Question.js";
import { Record as I$x } from "./external/@phosphor-icons/react/dist/csr/Record.js";
import { RocketLaunch as l$7 } from "./external/@phosphor-icons/react/dist/csr/RocketLaunch.js";
import { Selection as R$1 } from "./external/@phosphor-icons/react/dist/csr/Selection.js";
import { Shapes as I$y } from "./external/@phosphor-icons/react/dist/csr/Shapes.js";
import { ShareNetwork as k$2 } from "./external/@phosphor-icons/react/dist/csr/ShareNetwork.js";
import { Shield as I$z } from "./external/@phosphor-icons/react/dist/csr/Shield.js";
import { ShoppingBag as l$8 } from "./external/@phosphor-icons/react/dist/csr/ShoppingBag.js";
import { ShoppingCart as w$t } from "./external/@phosphor-icons/react/dist/csr/ShoppingCart.js";
import { SignIn as w$u } from "./external/@phosphor-icons/react/dist/csr/SignIn.js";
import { SignOut as w$v } from "./external/@phosphor-icons/react/dist/csr/SignOut.js";
import { SketchLogo as l$9 } from "./external/@phosphor-icons/react/dist/csr/SketchLogo.js";
import { Sliders as R$2 } from "./external/@phosphor-icons/react/dist/csr/Sliders.js";
import { Smiley as I$A } from "./external/@phosphor-icons/react/dist/csr/Smiley.js";
import { SpeakerHigh as l$a } from "./external/@phosphor-icons/react/dist/csr/SpeakerHigh.js";
import { Sparkle as I$B } from "./external/@phosphor-icons/react/dist/csr/Sparkle.js";
import { SquaresFour as w$w } from "./external/@phosphor-icons/react/dist/csr/SquaresFour.js";
import { Star as R$3 } from "./external/@phosphor-icons/react/dist/csr/Star.js";
import { TextH as H$2 } from "./external/@phosphor-icons/react/dist/csr/TextH.js";
import { Ticket as I$C } from "./external/@phosphor-icons/react/dist/csr/Ticket.js";
import { Trash as I$D } from "./external/@phosphor-icons/react/dist/csr/Trash.js";
import { TrendDown as I$E } from "./external/@phosphor-icons/react/dist/csr/TrendDown.js";
import { TrendUp as R$4 } from "./external/@phosphor-icons/react/dist/csr/TrendUp.js";
import { Trophy as w$x } from "./external/@phosphor-icons/react/dist/csr/Trophy.js";
import { UploadSimple as R$5 } from "./external/@phosphor-icons/react/dist/csr/UploadSimple.js";
import { User as R$6 } from "./external/@phosphor-icons/react/dist/csr/User.js";
import { UserCircle as I$F } from "./external/@phosphor-icons/react/dist/csr/UserCircle.js";
import { UserMinus as I$G } from "./external/@phosphor-icons/react/dist/csr/UserMinus.js";
import { UserPlus as I$H } from "./external/@phosphor-icons/react/dist/csr/UserPlus.js";
import { Users as R$7 } from "./external/@phosphor-icons/react/dist/csr/Users.js";
import { Video as R$8 } from "./external/@phosphor-icons/react/dist/csr/Video.js";
import { VideoCamera as I$I } from "./external/@phosphor-icons/react/dist/csr/VideoCamera.js";
import { Warning as I$J } from "./external/@phosphor-icons/react/dist/csr/Warning.js";
import { WarningOctagon as I$K } from "./external/@phosphor-icons/react/dist/csr/WarningOctagon.js";
import { Webcam as I$L } from "./external/@phosphor-icons/react/dist/csr/Webcam.js";
import { WebhooksLogo as k$3 } from "./external/@phosphor-icons/react/dist/csr/WebhooksLogo.js";
import { X as R$9 } from "./external/@phosphor-icons/react/dist/csr/X.js";
import { XCircle as I$M } from "./external/@phosphor-icons/react/dist/csr/XCircle.js";
import { Yarn as R$a } from "./external/@phosphor-icons/react/dist/csr/Yarn.js";
const AndroidLogo = /* @__PURE__ */ hofPhosphorAdapter(
  A
);
const AppleLogo = /* @__PURE__ */ hofPhosphorAdapter(A$1);
const AppStoreLogo = /* @__PURE__ */ hofPhosphorAdapter(
  A$2
);
const ArrowArcLeft = /* @__PURE__ */ hofPhosphorAdapter(
  I
);
const ArrowCircleUp = /* @__PURE__ */ hofPhosphorAdapter(
  C
);
const ArrowDown = /* @__PURE__ */ hofPhosphorAdapter(D);
const ArrowDownLeft = /* @__PURE__ */ hofPhosphorAdapter(
  D$1
);
const ArrowDownRight = /* @__PURE__ */ hofPhosphorAdapter(
  d
);
const ArrowLeft = /* @__PURE__ */ hofPhosphorAdapter(I$1);
const ArrowRight = /* @__PURE__ */ hofPhosphorAdapter(
  d$1
);
const ArrowsLeftRight = /* @__PURE__ */ hofPhosphorAdapter(
  d$2
);
const ArrowsInSimple = /* @__PURE__ */ hofPhosphorAdapter(
  A$3
);
const ArrowsOutSimple = /* @__PURE__ */ hofPhosphorAdapter(
  A$4
);
const ArrowSquareIn = /* @__PURE__ */ hofPhosphorAdapter(
  q
);
const ArrowSquareOut = /* @__PURE__ */ hofPhosphorAdapter(
  q$1
);
const ArrowUp = /* @__PURE__ */ hofPhosphorAdapter(I$2);
const ArrowUpLeft = /* @__PURE__ */ hofPhosphorAdapter(
  I$3
);
const ArrowUpRight = /* @__PURE__ */ hofPhosphorAdapter(
  d$3
);
const ArrowUUpLeft = /* @__PURE__ */ hofPhosphorAdapter(
  A$5
);
const ArrowUUpRight = /* @__PURE__ */ hofPhosphorAdapter(
  n
);
const ArrowsClockwise = /* @__PURE__ */ hofPhosphorAdapter(
  A$6
);
const ArrowsDownUp = /* @__PURE__ */ hofPhosphorAdapter(
  D$2
);
const Article = /* @__PURE__ */ hofPhosphorAdapter(I$4);
const Bell = /* @__PURE__ */ hofPhosphorAdapter(I$5);
const BookBookmark = /* @__PURE__ */ hofPhosphorAdapter(
  w
);
const BookmarkSimple = /* @__PURE__ */ hofPhosphorAdapter(
  w$1
);
const BookOpenText = /* @__PURE__ */ hofPhosphorAdapter(
  l
);
const Books = /* @__PURE__ */ hofPhosphorAdapter(w$2);
const Broadcast = /* @__PURE__ */ hofPhosphorAdapter(I$6);
const Browsers = /* @__PURE__ */ hofPhosphorAdapter(I$7);
const CalendarBlank = /* @__PURE__ */ hofPhosphorAdapter(
  w$3
);
const CaretDoubleDown = /* @__PURE__ */ hofPhosphorAdapter(
  d$4
);
const CaretDoubleUp = /* @__PURE__ */ hofPhosphorAdapter(
  w$4
);
const CaretDown = /* @__PURE__ */ hofPhosphorAdapter(D$3);
const CaretLeft = /* @__PURE__ */ hofPhosphorAdapter(I$8);
const CaretRight = /* @__PURE__ */ hofPhosphorAdapter(
  l$1
);
const CaretUp = /* @__PURE__ */ hofPhosphorAdapter(I$9);
const ChartBar = /* @__PURE__ */ hofPhosphorAdapter(w$5);
const ChartPie = /* @__PURE__ */ hofPhosphorAdapter(C$1);
const Chats = /* @__PURE__ */ hofPhosphorAdapter(C$2);
const ChatText = /* @__PURE__ */ hofPhosphorAdapter(w$6);
const Check = /* @__PURE__ */ hofPhosphorAdapter(w$7);
const CheckCircle = /* @__PURE__ */ hofPhosphorAdapter(
  k
);
const CirclesThree = /* @__PURE__ */ hofPhosphorAdapter(
  C$3
);
const ClipboardText = /* @__PURE__ */ hofPhosphorAdapter(
  w$8
);
const Clock = /* @__PURE__ */ hofPhosphorAdapter(C$4);
const CloudCheck = /* @__PURE__ */ hofPhosphorAdapter(
  k$1
);
const CloudSlash = /* @__PURE__ */ hofPhosphorAdapter(
  w$9
);
const Coffee = /* @__PURE__ */ hofPhosphorAdapter(I$a);
const Columns = /* @__PURE__ */ hofPhosphorAdapter(C$5);
const Confetti = /* @__PURE__ */ hofPhosphorAdapter(I$b);
const Copy = /* @__PURE__ */ hofPhosphorAdapter(C$6);
const CodesandboxLogo = /* @__PURE__ */ hofPhosphorAdapter(
  l$2
);
const CreditCard = /* @__PURE__ */ hofPhosphorAdapter(
  I$c
);
const CrownSimple = /* @__PURE__ */ hofPhosphorAdapter(
  I$d
);
const CurrencyCircleDollar = /* @__PURE__ */ hofPhosphorAdapter(
  u
);
const CurrencyEth = /* @__PURE__ */ hofPhosphorAdapter(
  l$3
);
const CursorClick = /* @__PURE__ */ hofPhosphorAdapter(
  u$1
);
const Desktop = /* @__PURE__ */ hofPhosphorAdapter(D$4);
const DeviceMobileCamera = /* @__PURE__ */ hofPhosphorAdapter(
  w$a
);
const DotOutline = /* @__PURE__ */ hofPhosphorAdapter(
  D$5
);
const DotsSixVertical = /* @__PURE__ */ hofPhosphorAdapter(
  D$6,
  { bold: true }
);
const DotsThreeVertical = /* @__PURE__ */ hofPhosphorAdapter(
  D$7,
  { bold: true }
);
const DownloadSimple = /* @__PURE__ */ hofPhosphorAdapter(
  I$e
);
const Envelope = /* @__PURE__ */ hofPhosphorAdapter(w$b);
const EnvelopeOpen = /* @__PURE__ */ hofPhosphorAdapter(
  w$c
);
const Exam = /* @__PURE__ */ hofPhosphorAdapter(w$d);
const Export = /* @__PURE__ */ hofPhosphorAdapter(w$e);
const Eye = /* @__PURE__ */ hofPhosphorAdapter(w$f);
const EyeSlash = /* @__PURE__ */ hofPhosphorAdapter(d$5);
const FacebookLogo = /* @__PURE__ */ hofPhosphorAdapter(
  l$4
);
const File = /* @__PURE__ */ hofPhosphorAdapter(I$f);
const FileArrowDown = /* @__PURE__ */ hofPhosphorAdapter(
  D$8
);
const FileMinus = /* @__PURE__ */ hofPhosphorAdapter(F);
const FilePdf = /* @__PURE__ */ hofPhosphorAdapter(I$g);
const FilePlus = /* @__PURE__ */ hofPhosphorAdapter(F$1);
const FileZip = /* @__PURE__ */ hofPhosphorAdapter(I$h);
const Files = /* @__PURE__ */ hofPhosphorAdapter(I$i);
const FileText = /* @__PURE__ */ hofPhosphorAdapter(F$2);
const FilmSlate = /* @__PURE__ */ hofPhosphorAdapter(I$j);
const Flag = /* @__PURE__ */ hofPhosphorAdapter(F$3);
const Folder = /* @__PURE__ */ hofPhosphorAdapter(w$g);
const FunnelSimple = /* @__PURE__ */ hofPhosphorAdapter(
  F$4
);
const Gear = /* @__PURE__ */ hofPhosphorAdapter(I$k);
const Gift = /* @__PURE__ */ hofPhosphorAdapter(I$l);
const GoogleLogo = /* @__PURE__ */ hofPhosphorAdapter(
  G
);
const GooglePlayLogo = /* @__PURE__ */ hofPhosphorAdapter(
  w$h
);
const GraduationCap = /* @__PURE__ */ hofPhosphorAdapter(
  C$7
);
const HandPointing = /* @__PURE__ */ hofPhosphorAdapter(
  H
);
const Handshake = /* @__PURE__ */ hofPhosphorAdapter(w$i);
const Heart = /* @__PURE__ */ hofPhosphorAdapter(I$m);
const House = /* @__PURE__ */ hofPhosphorAdapter(H$1);
const IdentificationCard = /* @__PURE__ */ hofPhosphorAdapter(
  C$8
);
const Image = /* @__PURE__ */ hofPhosphorAdapter(w$j);
const Info = /* @__PURE__ */ hofPhosphorAdapter(R);
const IntersectThree = /* @__PURE__ */ hofPhosphorAdapter(
  w$k
);
const Key = /* @__PURE__ */ hofPhosphorAdapter(I$n);
const Layout = /* @__PURE__ */ hofPhosphorAdapter(w$l);
const Lifebuoy = /* @__PURE__ */ hofPhosphorAdapter(u$2);
const Lightbulb = /* @__PURE__ */ hofPhosphorAdapter(d$6);
const Lightning = /* @__PURE__ */ hofPhosphorAdapter(w$m);
const Link = /* @__PURE__ */ hofPhosphorAdapter(I$o);
const LinkedinLogo = /* @__PURE__ */ hofPhosphorAdapter(
  l$5
);
const List = /* @__PURE__ */ hofPhosphorAdapter(L);
const ListBullets = /* @__PURE__ */ hofPhosphorAdapter(
  w$n
);
const ListChecks = /* @__PURE__ */ hofPhosphorAdapter(
  w$o
);
const LockSimple = /* @__PURE__ */ hofPhosphorAdapter(
  I$p
);
const MagnifyingGlass = /* @__PURE__ */ hofPhosphorAdapter(
  w$p
);
const MapPinLine = /* @__PURE__ */ hofPhosphorAdapter(
  L$1
);
const Medal = /* @__PURE__ */ hofPhosphorAdapter(M);
const Megaphone = /* @__PURE__ */ hofPhosphorAdapter(w$q);
const Microphone = /* @__PURE__ */ hofPhosphorAdapter(
  I$q
);
const Minus = /* @__PURE__ */ hofPhosphorAdapter(I$r);
const Money = /* @__PURE__ */ hofPhosphorAdapter(I$s);
const Notebook = /* @__PURE__ */ hofPhosphorAdapter(l$6);
const Pause = /* @__PURE__ */ hofPhosphorAdapter(I$t);
const PaintBrushHousehold = /* @__PURE__ */ hofPhosphorAdapter(
  B
);
const Paperclip = /* @__PURE__ */ hofPhosphorAdapter(P);
const PaperPlaneRight = /* @__PURE__ */ hofPhosphorAdapter(
  h
);
const PencilSimple = /* @__PURE__ */ hofPhosphorAdapter(
  P$1
);
const Play = /* @__PURE__ */ hofPhosphorAdapter(I$u);
const PlayCircle = /* @__PURE__ */ hofPhosphorAdapter(
  C$9
);
const Plugs = /* @__PURE__ */ hofPhosphorAdapter(w$r);
const Plus = /* @__PURE__ */ hofPhosphorAdapter(I$v);
const PresentationChart = /* @__PURE__ */ hofPhosphorAdapter(
  C$a
);
const Prohibit = /* @__PURE__ */ hofPhosphorAdapter(w$s);
const PushPinSimple = /* @__PURE__ */ hofPhosphorAdapter(
  u$3
);
const Question = /* @__PURE__ */ hofPhosphorAdapter(I$w);
const Record = /* @__PURE__ */ hofPhosphorAdapter(I$x);
const RocketLaunch = /* @__PURE__ */ hofPhosphorAdapter(
  l$7
);
const Selection = /* @__PURE__ */ hofPhosphorAdapter(R$1);
const Shapes = /* @__PURE__ */ hofPhosphorAdapter(I$y);
const ShareNetwork = /* @__PURE__ */ hofPhosphorAdapter(
  k$2
);
const Shield = /* @__PURE__ */ hofPhosphorAdapter(I$z);
const ShoppingBag = /* @__PURE__ */ hofPhosphorAdapter(
  l$8
);
const ShoppingCart = /* @__PURE__ */ hofPhosphorAdapter(
  w$t
);
const SignIn = /* @__PURE__ */ hofPhosphorAdapter(w$u);
const SignOut = /* @__PURE__ */ hofPhosphorAdapter(w$v);
const SketchLogo = /* @__PURE__ */ hofPhosphorAdapter(
  l$9
);
const Sliders = /* @__PURE__ */ hofPhosphorAdapter(R$2);
const Smiley = /* @__PURE__ */ hofPhosphorAdapter(I$A);
const SpeakerHigh = /* @__PURE__ */ hofPhosphorAdapter(
  l$a
);
const Sparkle = /* @__PURE__ */ hofPhosphorAdapter(I$B);
const SquaresFour = /* @__PURE__ */ hofPhosphorAdapter(
  w$w
);
const Star = /* @__PURE__ */ hofPhosphorAdapter(R$3);
const TextH = /* @__PURE__ */ hofPhosphorAdapter(H$2);
const Ticket = /* @__PURE__ */ hofPhosphorAdapter(I$C);
const Trash = /* @__PURE__ */ hofPhosphorAdapter(I$D);
const TrendDown = /* @__PURE__ */ hofPhosphorAdapter(I$E);
const TrendUp = /* @__PURE__ */ hofPhosphorAdapter(R$4);
const Trophy = /* @__PURE__ */ hofPhosphorAdapter(w$x);
const UploadSimple = /* @__PURE__ */ hofPhosphorAdapter(
  R$5
);
const User = /* @__PURE__ */ hofPhosphorAdapter(R$6);
const UserCircle = /* @__PURE__ */ hofPhosphorAdapter(
  I$F
);
const UserMinus = /* @__PURE__ */ hofPhosphorAdapter(I$G);
const UserPlus = /* @__PURE__ */ hofPhosphorAdapter(I$H);
const Users = /* @__PURE__ */ hofPhosphorAdapter(R$7);
const Video = /* @__PURE__ */ hofPhosphorAdapter(R$8);
const VideoCamera = /* @__PURE__ */ hofPhosphorAdapter(
  I$I
);
const Warning = /* @__PURE__ */ hofPhosphorAdapter(I$J);
const WarningOctagon = /* @__PURE__ */ hofPhosphorAdapter(
  I$K
);
const Webcam = /* @__PURE__ */ hofPhosphorAdapter(I$L);
const WebhooksLogo = /* @__PURE__ */ hofPhosphorAdapter(
  k$3
);
const X = /* @__PURE__ */ hofPhosphorAdapter(R$9);
const XCircle = /* @__PURE__ */ hofPhosphorAdapter(I$M);
const Yarn = /* @__PURE__ */ hofPhosphorAdapter(R$a);
export {
  AndroidLogo,
  AppStoreLogo,
  AppleLogo,
  ArrowArcLeft,
  ArrowCircleUp,
  ArrowDown,
  ArrowDownLeft,
  ArrowDownRight,
  ArrowLeft,
  ArrowRight,
  ArrowSquareIn,
  ArrowSquareOut,
  ArrowUUpLeft,
  ArrowUUpRight,
  ArrowUp,
  ArrowUpLeft,
  ArrowUpRight,
  ArrowsClockwise,
  ArrowsDownUp,
  ArrowsInSimple,
  ArrowsLeftRight,
  ArrowsOutSimple,
  Article,
  Bell,
  BookBookmark,
  BookOpenText,
  BookmarkSimple,
  Books,
  Broadcast,
  Browsers,
  CalendarBlank,
  CaretDoubleDown,
  CaretDoubleUp,
  CaretDown,
  CaretLeft,
  CaretRight,
  CaretUp,
  ChartBar,
  ChartPie,
  ChatText,
  Chats,
  Check,
  CheckCircle,
  CirclesThree,
  ClipboardText,
  Clock,
  CloudCheck,
  CloudSlash,
  CodesandboxLogo,
  Coffee,
  Columns,
  Confetti,
  Copy,
  CreditCard,
  CrownSimple,
  CurrencyCircleDollar,
  CurrencyEth,
  CursorClick,
  Desktop,
  DeviceMobileCamera,
  DotOutline,
  DotsSixVertical,
  DotsThreeVertical,
  DownloadSimple,
  Envelope,
  EnvelopeOpen,
  Exam,
  Export,
  Eye,
  EyeSlash,
  FacebookLogo,
  File,
  FileArrowDown,
  FileMinus,
  FilePdf,
  FilePlus,
  FileText,
  FileZip,
  Files,
  FilmSlate,
  Flag,
  Folder,
  FunnelSimple,
  Gear,
  Gift,
  GoogleLogo,
  GooglePlayLogo,
  GraduationCap,
  HandPointing,
  Handshake,
  Heart,
  House,
  IdentificationCard,
  Image,
  Info,
  IntersectThree,
  Key,
  Layout,
  Lifebuoy,
  Lightbulb,
  Lightning,
  Link,
  LinkedinLogo,
  List,
  ListBullets,
  ListChecks,
  LockSimple,
  MagnifyingGlass,
  MapPinLine,
  Medal,
  Megaphone,
  Microphone,
  Minus,
  Money,
  Notebook,
  PaintBrushHousehold,
  PaperPlaneRight,
  Paperclip,
  Pause,
  PencilSimple,
  Play,
  PlayCircle,
  Plugs,
  Plus,
  PresentationChart,
  Prohibit,
  PushPinSimple,
  Question,
  Record,
  RocketLaunch,
  Selection,
  Shapes,
  ShareNetwork,
  Shield,
  ShoppingBag,
  ShoppingCart,
  SignIn,
  SignOut,
  SketchLogo,
  Sliders,
  Smiley,
  Sparkle,
  SpeakerHigh,
  SquaresFour,
  Star,
  TextH,
  Ticket,
  Trash,
  TrendDown,
  TrendUp,
  Trophy,
  UploadSimple,
  User,
  UserCircle,
  UserMinus,
  UserPlus,
  Users,
  Video,
  VideoCamera,
  Warning,
  WarningOctagon,
  Webcam,
  WebhooksLogo,
  X,
  XCircle,
  Yarn
};
